export default "__VITE_ASSET__D$pFbbee__"